import type { MonthlyPoint } from '../../../hooks/useReports';

interface Props {
  monthlyData: MonthlyPoint[];
}

const fmt = (v: number) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const MonthlyComparison = ({ monthlyData }: Props) => {
  if (!monthlyData.length) return null;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-100">
            <th className="text-left py-2 px-3 text-[11px] font-600 text-gray-400 uppercase tracking-wider">Mês</th>
            <th className="text-right py-2 px-3 text-[11px] font-600 text-gray-400 uppercase tracking-wider">Receitas</th>
            <th className="text-right py-2 px-3 text-[11px] font-600 text-gray-400 uppercase tracking-wider">Despesas</th>
            <th className="text-right py-2 px-3 text-[11px] font-600 text-gray-400 uppercase tracking-wider">Saldo</th>
          </tr>
        </thead>
        <tbody>
          {[...monthlyData].reverse().map((row, i) => (
            <tr key={i} className="border-b border-gray-50 hover:bg-gray-50/60 transition-colors">
              <td className="py-2.5 px-3 text-[13px] font-500 text-gray-700 capitalize">{row.mesLabel}</td>
              <td className="py-2.5 px-3 text-right text-[13px] font-600 text-emerald-600">{fmt(row.receitas)}</td>
              <td className="py-2.5 px-3 text-right text-[13px] font-600 text-red-400">{fmt(row.despesas)}</td>
              <td className={`py-2.5 px-3 text-right text-[13px] font-700 ${row.saldo >= 0 ? 'text-emerald-600' : 'text-red-500'}`}>
                {row.saldo >= 0 ? '+' : ''}{fmt(row.saldo)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
